// extracted by mini-css-extract-plugin
export default {"imageWrapper":"HM-z","twoColumnImage":"IM-z"};